import { render, staticRenderFns } from "./personal_trainer.vue?vue&type=template&id=a55eabda&"
import script from "./personal_trainer.vue?vue&type=script&lang=js&"
export * from "./personal_trainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports